import { ApiRequest } from "../../Common";
import { User } from "..";
import { endpoints } from "../Constants/endpoints";

// eslint-disable-next-line consistent-return
export const getUsers = async () => {
  const response = await ApiRequest.fromPath(endpoints.users.getAll())
    .withAuthHeader()
    .get();
  if (response.ok) {
    const usersResponse: { payload: User[] } = await response.json();
    return usersResponse.payload;
  }
  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }
};
